import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet><app-spinner></app-spinner></router-outlet>',
  encapsulation: ViewEncapsulation.None, // 无样式包装
  styleUrls: [
    '../../node_modules/sweetalert2/dist/sweetalert2.min.css'
  ]
})
export class AppComponent {
  title = '星矢科技';
}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/app.component.ts